import { FormControlLabel, SelectChangeEvent } from "@mui/material";
import { Box } from "@mui/system";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaCheckbox from "../../../../../components/common/BriaCheckbox/BriaCheckbox.tsx";
import StaticDropdown, { AspectRatio } from "../../../../../components/common/DropDowns/StaticDropdown.tsx";
import InputLayout from "../../../../../layout/InputLayout/InputLayout.tsx";
import { ImageGenerationIframeConfig } from "../../../../../models/new-iframe.ts";
import iframeStore from "../../../iframe-store.tsx";
import styles from "./IframeImageGenerationConfig.module.scss";
import IframeImageGenerationFoundationModels from "./IframeImageGenerationFoundationModels.tsx";
import IframeImageGenerationTgModels from "./IframeImageGenerationTgModels.tsx";

const IframeImageGenerationConfig = () => {
	const { iframeForm, handleFormChange } = iframeStore;
	const { t } = useTranslation("translation", { keyPrefix: "newIframes.editor.form.imageGenerationConfig" });

	const handleGenAspectRatioChange = (e: SelectChangeEvent<AspectRatio>) => {
		handleFormChange("config", {
			...iframeForm.config,
			image_generation_config: {
				...(iframeForm.config.image_generation_config ?? {}),
				default_aspect_ratio: e.target.value as AspectRatio,
			},
		});
	};

	const handleCheckboxChange = (key: keyof ImageGenerationIframeConfig, checked: boolean) => {
		const existingConfig = iframeForm.config.image_generation_config;
		const updatedConfig: Partial<ImageGenerationIframeConfig> = {
			...existingConfig,
			[key]: checked,
		};

		handleFormChange("config", {
			...iframeForm.config,
			image_generation_config: {
				...updatedConfig,
			} as ImageGenerationIframeConfig,
		});
	};

	return (
		<Box className={styles.container}>
			<InputLayout label={t("foundationModels.label")}>
				<IframeImageGenerationFoundationModels />
			</InputLayout>
			<InputLayout label={t("tgModels.label")}>
				<IframeImageGenerationTgModels />
			</InputLayout>
			<InputLayout label={t("defaultGenAspectRatio.label")}>
				<StaticDropdown<AspectRatio>
					type="aspectRatio"
					value={iframeForm?.config.image_generation_config?.default_aspect_ratio}
					onChange={handleGenAspectRatioChange}
					placeholder={t("defaultGenAspectRatio.placeholder")}
					className={styles.dropDown}
					width={"-webkit-fill-available"}
				/>
			</InputLayout>
			<Box className={styles.checkboxContainer}>
				<FormControlLabel
					control={
						<BriaCheckbox
							checked={iframeForm?.config.image_generation_config?.enable_restyle_portraits ?? false}
							onChange={(e) => handleCheckboxChange("enable_restyle_portraits", e.target.checked)}
						/>
					}
					label={t("checkboxes.enableRestylePortraits")}
				/>
			</Box>
		</Box>
	);
};

export default observer(IframeImageGenerationConfig);
